export default {
      id: "flex-flexDirection-column-usage",
      viewBox: "0 0 40 40",
      url: "assets/" + "sprite.svg#flex-flexDirection-column-usage",
      toString: function () {
        return this.url;
      }
    }